import type { LucideProps } from 'lucide-react'

export const SendEmail = (props: LucideProps) => {
	return (
		<svg
			width="74"
			height="74"
			viewBox="0 0 74 74"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<title>Send email</title>
			<path
				d="M30.714 41.2874L1.64258 28.0731L70.3569 1.64453L43.9283 70.3588L30.714 41.2874ZM30.714 41.2874L46.5711 25.4302"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
